import { Button, Flex, Loader, Text } from '@components';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { TableContainer } from './Reports.styles';
import { useUserProductReportsQuery } from '@features/api/userPortfolioSlice';

export const Reports = () => {
  const { data: reports, isLoading, isFetching } = useUserProductReportsQuery();

  const downloadFile = (url: string, filename: string) => {
    const req = new XMLHttpRequest();

    req.open('GET', url, true);
    req.responseType = 'blob';
    req.onload = function () {
      const blob = new Blob([req.response], {
        type: 'application/pdf',
      });

      const windowUrl = window.URL || window.webkitURL;
      const href = windowUrl.createObjectURL(blob);
      const a = document.createElement('a');
      a.setAttribute('download', filename);
      a.setAttribute('href', href);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    };
    req.onerror = function () {
      window.open(url);
    };

    req.send();
  };

  if (isLoading || isFetching) {
    return <Loader isLoading={isLoading || isFetching} />;
  }

  return (
    <Flex flex={1} flexDirection='column' mt={16}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align='center'>
                <Text variant='bodyBig' fontWeight='fontWeightSemiBold'>
                  <FormattedMessage id='portfolio.reports.product' />
                </Text>
              </TableCell>
              <TableCell align='center'>
                <Text variant='bodyBig' fontWeight='fontWeightSemiBold'>
                  <FormattedMessage id='portfolio.reports.quarter' />
                </Text>
              </TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {reports?.length ? (
              reports?.map((x) => (
                <TableRow>
                  <TableCell align='center'>{x.productName}</TableCell>
                  <TableCell align='center'>
                    {x.quarter} {x.year}
                  </TableCell>
                  <TableCell align='right'>
                    <Button
                      variant='tertiary'
                      startIcon={<DownloadIcon />}
                      onClick={() => downloadFile(x.url, x.productName)}
                    >
                      <FormattedMessage id='portfolio.reports.download' />
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell align='center' colSpan={3}>
                  <Text variant='h4' fontWeight='fontWeightSemiBold'>
                    <FormattedMessage id='portfolio.reports.noReports' />
                  </Text>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Flex>
  );
};
